import { IParametersResponse } from '../../../../model/apm/parameters/response/parameters-response';
import { ParametersForm, toParametersForm } from '../components/parameters-utils';

export type ParametersState = {
    parameters?: IParametersResponse;
    form: ParametersForm;
    loading: boolean;
    isDirty: boolean;
    showValidationErrors: boolean;
    tab: number;
};

export enum ACTION_TYPES {
    setParameters = 'setParameters',
    setLoading = 'setLoading',
    updateForm = 'updateForm',
    resetForm = 'resetForm',
    setShowValidationErrors = 'setShowValidationErrors',
    setTab = 'setTab',
}

export const ParametersReducer = (state: ParametersState, action: any): ParametersState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setParameters:
            return { ...state, parameters: payload, form: toParametersForm(payload), isDirty: false, showValidationErrors: false };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.updateForm:
            return { ...state, form: { ...state.form, ...payload }, isDirty: true };
        case ACTION_TYPES.resetForm:
            return { ...state, form: toParametersForm(state.parameters), isDirty: false, showValidationErrors: false };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        case ACTION_TYPES.setTab:
            return { ...state, tab: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
